// src/redux/Market/market.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../lib/api";

const err = (e) => e?.response?.data || e?.message;

export const fetchMarketPlace = createAsyncThunk(
  "market/fetchMarketPlace",
  async ({ mainId = "", subId = "" } = {}, { signal, rejectWithValue }) => {
    try {
      const r = await api.get("filter-market", {
        params: { main_id: mainId, category_id: subId },
        signal
      });
      return r.data.data;
    } catch (e) {
      return rejectWithValue(err(e));
    }
  }
);

const initialState = {
  marketData: null,
  marketPlace: null,
  marketNav: null,
  savedMarket: null,
  postedMarket: null,
  status: "idle",
  error: null
};

const marketRedux = createSlice({
  name: "market",
  initialState,
  reducers: {
    setMarketData: (state, actions) => { state.marketData = actions.payload; },
    setMarketPlace: (state, actions) => { state.marketPlace = actions.payload; },
    setMarketNav: (state, actions) => { state.marketNav = actions.payload; },
    setSavedMarket: (state, actions) => { state.savedMarket = actions.payload; },
    setPostedMarket: (state, actions) => { state.postedMarket = actions.payload; }
  },
  extraReducers: (b) => {
    b.addCase(fetchMarketPlace.pending, (s) => { s.status = "loading"; s.error = null; })
     .addCase(fetchMarketPlace.fulfilled, (s, a) => { s.status = "succeeded"; s.marketPlace = a.payload; })
     .addCase(fetchMarketPlace.rejected, (s, a) => { s.status = "failed"; s.error = a.payload || a.error.message; });
  }
});

export const marketState = (state) => state.market;

export const {
  setMarketData,
  setMarketPlace,
  setMarketNav,
  setSavedMarket,
  setPostedMarket
} = marketRedux.actions;

export default marketRedux.reducer;
